import { render, staticRenderFns } from "./OscillographyAlarmChart.vue?vue&type=template&id=58237471&scoped=true&"
import script from "./OscillographyAlarmChart.vue?vue&type=script&lang=js&"
export * from "./OscillographyAlarmChart.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAlarmChart.vue?vue&type=style&index=0&id=58237471&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58237471",
  null
  
)

export default component.exports